export default __webpack_public_path__ + "230ce5b39afe1f8416de787f9d3b828d.svg";